module.exports = __webpack_public_path__ + "static/media/park-ranger.481ead6e.jpg";